"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Given a list of complex values and a function that returns the field to find the max of, return the "max" item.
 * For two elements returning the same max, the first max will be returned.
 * @param values a list of values to search for the max of
 * @param mapper a function to apply to each element that returns the field being compared for max
 * @return the element that is the "max" based on the above conditions or undefined if the list is empty
 */
function maxOf(values, mapper) {
    if (!values.length) {
        return undefined;
    }
    return values.reduce((currentMax, currentValue) => {
        return Math.max(mapper(currentMax), mapper(currentValue)) === mapper(currentMax) ? currentMax : currentValue;
    }, values[0]);
}
exports.default = maxOf;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWF4T2YuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvbWF4T2YudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQTs7Ozs7O0dBTUc7QUFDSCxTQUF3QixLQUFLLENBQUksTUFBd0IsRUFBRSxNQUE2QjtJQUN0RixJQUFHLENBQUMsTUFBTSxDQUFDLE1BQU0sRUFBRTtRQUNqQixPQUFPLFNBQVMsQ0FBQztLQUNsQjtJQUVELE9BQU8sTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDLFVBQWEsRUFBRSxZQUFlLEVBQUUsRUFBRTtRQUN0RCxPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLFVBQVUsQ0FBQyxFQUFFLE1BQU0sQ0FBQyxZQUFZLENBQUMsQ0FBQyxLQUFLLE1BQU0sQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFBLENBQUMsQ0FBQyxZQUFZLENBQUE7SUFDN0csQ0FBQyxFQUFFLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0FBQ2YsQ0FBQztBQVJELHdCQVFDIn0=